<div
  class="parent-el"
  data-test-id="expansion-group"
  @parent
>
  <div
    class="group-header cursor-pointer flex gap-x-1 items-center"
    (click)="toggle()"
  >
    <ng-content select="[slot='title-before-arrow']"></ng-content>

    @if (!isArrowHidden) {
      <svg-icon
        class="arrow text-navy-90 transform"
        [class.-rotate-90]="!expanded"
        [src]="'arrow-down'"
      ></svg-icon>
    }

    <ng-content></ng-content>
  </div>

  <div
    class="group-content overflow-hidden mt-3"
    [@expandCollapse]="expandState"
    (@expandCollapse.done)="onAnimationDone()"
  >
    <ng-content select="[slot='group-content']"></ng-content>
  </div>
</div>

